/**
 * Deep R, intermission 2: three keys sit in the walls of an island, and two fireflies circle it.
 * Slip into the ring, take the keys, open the vaults (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepR: CaveDef = {
  id: 'R',
  name: 'KEYRING',
  hint: 'Move with the fireflies, not against them.',
  intermission: true,
  colors: [2, 12, 3],
  diamondValue: 25,
  extraValue: 35,
  fill: { base: '.', items: [['d', 20]] },
  levels: [
    { seed: 6801, diamonds: 10, time: 50 },
    { seed: 6802, diamonds: 12, time: 46 },
    { seed: 6803, diamonds: 13, time: 42 },
    { seed: 6804, diamonds: 14, time: 38 },
    { seed: 6805, diamonds: 15, time: 35 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWW',
    'WP.........6dddddddW',
    'W...wwwwwwwwwwwwwwwW',
    'W...w    f     w...W',
    'W...w w1wwwwww w?d?W',
    'W.... wwwwwww2 .d?dW',
    'W...w 3wwwwwww w???W',
    'Wwwww     F    wwwwW',
    'Wddwwwwww.wwwwwwwddW',
    'Wdd4????????????5ddW',
    'Wddw..........X.wddW',
    'WWWWWWWWWWWWWWWWWWWW',
  ],
};
